import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import tileData from '../../common/tileData';
import Tile from '../common/Tile';
import InfoTile from '../common/InfoTile';
import ContactUs from '../home/ContactUs';
import HostelInfo from '../common/HostelInfo';


import MapContainer from '../common/MapContainer';

export default class ContactUsGrid extends Component {
  static propTypes = {

  };

  render() {
    const data = tileData.contact;
    return (
      <Grid className="page-grid contact-us-contact-us-grid" columns="equal">
        <Grid.Row stretched>
          <Grid.Column largeScreen={16} mobile={16} tablet={16}>
            <Tile
              key={1}
              link={false}
              imgUrl={data[0].imgUrl}
              title={data[0].title}
              description={data[0].description}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column largeScreen={8} mobile={16} tablet={16}>
            <ContactUs />
          </Grid.Column>
          <Grid.Column largeScreen={8} mobile={16} tablet={16}>
            <HostelInfo />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          {/* Hostel Location */}
          <Grid.Column width={16}>
            <MapContainer />
          </Grid.Column>
        </Grid.Row>

      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/contact-us/ContactUsGrid.js